import { defaultShippingAddressStyles } from "@insite/content-library/Widgets/AccountSettings/DefaultShippingAddress";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS } from "@tSurya/theme/design";
import { css } from "styled-components";


defaultShippingAddressStyles.headingText = {
    variant: "h5",
    css: css`
    margin-bottom: 0;
    color: ${getColor("text.main")};
    `,
}
defaultShippingAddressStyles.editLink ={
    css: css`
    margin-left: 10px;
    > span {
        &:hover {
            text-decoration-line: underline;
            color: ${getColor("text.link")};
        }
    }
    `,
}